;(function ( $, window, document, undefined ) {


    // Create the defaults once
    var pluginName = 'beEVP',
        defaults = {
            repopulate: false,
            loadingContainer: '.o-form__loading',
            apiUrl: window.location.origin,
            submitOnChange: false,
            type: 'POST'
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend( {}, defaults, options) ;

        this._defaults = defaults;
        this._name = pluginName;

        this.formData = {};

        if(this.$element.data('on-change')){
            this.options.submitOnChange = true;
        }

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;
        Plugin.watchSelectCompany();
    };

    Plugin.prototype.watchSelectCompany = function(){
        $('.js-master--company').on('change', function() {
            var selectedCompanyId = $(this).val();
            var $jobOffersSelect = $('.js-master--offers');

            if(selectedCompanyId !== $jobOffersSelect.data('company-id')) {
                $jobOffersSelect.val(null).trigger('change');
            }

            $jobOffersSelect.data('company-id', selectedCompanyId);
            $jobOffersSelect.attr('disabled', false);
        });
    };


    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );